import { Component } from '@angular/core';
import { /*IonicPage,*/NavController,/* Tabs,*/ AlertController } from 'ionic-angular';
//import { PcTabsPage } from '../pc-tabs/pc-tabs';
import { AuthProvider } from '../../providers/auth/auth';

//@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  user = { email : '', password : ''};

  constructor(public navCtrl: NavController, public auth : AuthProvider, public alertCtrl : AlertController) {
  }
  
  login()
  {
    this.auth.loginUser(this.user.email,this.user.password ).then((user) => {
      }
    )
     .catch(err=>{
      let alert = this.alertCtrl.create({
        title: 'Error',
        subTitle: err.message,
        buttons: ['Aceptar']
      });
      alert.present();
    })
  }

  getUser(){
    return this.user.email;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts